<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-text-field code="membre_nom" v-model="sasAutoInspection1.nom" disabled></opq-text-field>

    <opq-text-field code="membre_prenom" v-model="sasAutoInspection1.prenom" disabled></opq-text-field>

    <opq-text-field code="membre_numero" v-model="sasAutoInspection1.noPermis" disabled></opq-text-field>

    <opq-catalogue code="changement-pratique" v-model="sasAutoInspection1.changementPratique" :live="liveSasAutoInspection1(15406)"></opq-catalogue>

    <opq-catalogue
      :opq-if="estChangementPratique"
      code="changement-secteurs-dactivite"
      v-model="sasAutoInspection1.changementSecteursDActivite"
      :live="liveSasAutoInspection1(15407)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estChangementPratique"
      code="changement-activites-reservees"
      v-model="sasAutoInspection1.changementActivitesReservees"
      :live="liveSasAutoInspection1(15408)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estChangementPratique"
      code="changement-clientele"
      v-model="sasAutoInspection1.changementClientele"
      :live="liveSasAutoInspection1(15409)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estChangementPratique"
      code="changement-services-offerts"
      v-model="sasAutoInspection1.changementServicesOfferts"
      :live="liveSasAutoInspection1(15410)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estChangementPratique"
      code="changement-modeles-theoriques"
      v-model="sasAutoInspection1.changementModelesTheoriques"
      :live="liveSasAutoInspection1(15411)"
    ></opq-catalogue>

    <opq-memo
      :opq-if="estChangementPratique"
      code="changement-commentaires"
      v-model="sasAutoInspection1.commentaireModelesTheoriques"
      :live="liveSasAutoInspection1(15412)"
    ></opq-memo>

    <opq-catalogue
      :opq-if="estChangementPratique"
      code="ouverture-cabinet"
      v-model="sasAutoInspection1.ouvertureCabinetDepuis5Ans"
      :live="liveSasAutoInspection1(15413)"
    ></opq-catalogue>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormSimple, CataloguesHelper],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasAutoInspection1() {
      return this.sas.sasAutoIP1
    },

    estChangementPratique() {
      return this.estOui(this.sasAutoInspection1.changementPratique)
    }
  },

  methods: {
    liveSasAutoInspection1(cle) {
      return { endpoint: "/sas-auto-inspection-1/", cle: cle, fileId: this.sasAutoInspection1.id }
    }
  }
}
</script>

<style>
</style>